module.exports = {
  "country": "CH",
  "artist": "Esther Ofraim",
  "song": "T'en vas pas",
  "year": "1963",
  "place": "2",
  "spotify": ""
};